import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseModal } from 'src/app/core/models/classes/base-modal';
import { ICoords } from 'src/app/core/models/interfaces/coords';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LocationService } from 'src/app/core/services/location.service';
import { MapService } from 'src/app/core/services/map.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-device-location',
  templateUrl: './device-location.component.html',
  styleUrls: ['./device-location.component.scss'],
})
export class DeviceLocationComponent extends BaseModal implements OnInit {
  mapCenter
  map
  hideMap: boolean = true;
  deviceMarker: any;
  point: ICoords
  @Input() location: any;
  @Input() deviceId: any;
  @Input() deviceType: any;
  @Input() lastSeen: any;
  @Input() cityName: any;
  selectedDeviceInfo
  private _locationListener: Subscription
  constructor(private locationService: LocationService, private loadingService: LoadingService,
    private mapService: MapService, private modalService: ModalService) {
    super();
    super._modalService = modalService;
  }

  ngOnInit() {
    super.ngOnInit();
  }

  mapLoaded(ev) {
    this.loadingService.hideLoading();
    this.map = ev;
    this.location = JSON.parse(this.location);
    this.point = {
      latitude: this.location.geometry.coordinates[1],
      longitude: this.location.geometry.coordinates[0]
    }
    this.setDeviceMarker()
  }
  setDeviceMarker() {
    let type = this.deviceType;
    let marker
    let className = "map-marker";
    let image = environment.imageUrl;
    if (this.deviceType.includes('trap')) {
      className = "map-marker";
      type = "trap";
      image = image + "map-trap.svg";
    } else {
      type = "filiz";
      image = image + "map-filiz.svg";
      className = "map-marker";
    }

    marker = {
      geojson: this.location,
      className: className,
      type: this.deviceType,
      image: image,
      lastSeen: this.lastSeen,
      deviceId: this.deviceId,

    };
    this.mapService.addMarkerWithImage(this.map, marker, this.deviceMarkerClick);
  }
  deviceMarkerClick = (marker, center) => {
    center = center.map(e => Math.round(e * 1000) / 1000)
    this.selectedDeviceInfo = null;
    setTimeout(() => {
      this.selectedDeviceInfo = { marker: marker, center: center }
    }, 1);
  }

}
